import { useMutation } from '@tanstack/react-query';
import useSyncCache from '@/util/useSyncCache';
import { deleteConversation } from './api';
import { useChatbot } from './useChatbot';

export const useDeleteConversation = () => {
  const invalidateQueries = useSyncCache();
  const { conversation, createNew } = useChatbot();

  const { mutateAsync } = useMutation({
    mutationFn: deleteConversation,
    onSuccess: () => invalidateQueries([['chatbot', 'history']]),
  });

  return (conversationId: string) => {
    if (conversationId === conversation?.id) {
      createNew();
    }
    mutateAsync(conversationId);
  };
};
